<template>
    <v-layout align-center justify-center row fill-height class="pagina-curso">
        <div mt-5 class="contenido">
            <v-flex xs12 md12 mt-5 class="text-xs-center container-a">
                <img mt-5 class="img-presentacion animated bounceInDown dura-2" src="../assets/presentacion/portada-1.png"
                    alt="monitoreo">
                <h1 class="tittle-big  animated fadeInUp">
                    <span class="fb-light-italic">Curso: <br>
                    </span><span class="fb-semi-bold titulo">Monitoreo de <br><span class="titulo2">atmósferas</span>
                    </span>
                </h1>
            </v-flex>
            <v-flex xs12 md12 class="text-xs-center mt-2 container-a">
                <router-link class="animated bounceIn dura-2" to="/unidad1/0" tag="button">
                    <button class="mt-1 animated fadeInUp">
                        <img class="mt-1 animated fadeInUp" src="../assets/presentacion/4 boton inicio portada.svg"
                            alt="monitoreo">
                    </button>
                </router-link>
            </v-flex>
        </div>
        <v-layout align-end justify-end column fill-height class="pantalla">
            <img class="logoEcopetrol animated bounceInLeft dura-3" src="../assets/presentacion/5-logo-portada.png"
                alt="ecopetrol logo pantalla">
        </v-layout>
        <v-footer fixed height="85" class="mobile">
        </v-footer>
    </v-layout>
</template>

<script>
    import nextConditions from "../js/mixins/nextConditions";
    export default {
        mixins: [nextConditions],
        data() {
            return {}
        },
        methods: {},
    }
</script>

<style lang="scss" scoped>
    // NOT SCOPED !!
    @import '../sass/globals';

    .pagina-curso {
        background:  url('../assets/presentacion/estrellas-background.png'),linear-gradient(10deg, #042AB2 0%, #23CAD9 100%);
        background-size: 100% auto;
        height: auto;
        min-height: 100vh;
        overflow-y: auto;
        transition: all 0.3s ease-in-out;
        padding: 0px;
        position: relative;

        .contenido {
            max-width: 100%;
            min-width: 100vw;
            margin: auto;
            position: relative;
            overflow: hidden;
            height: auto;
            min-height: calc(100vh - 60px);
            padding-bottom: 2vh;
        }
    }

    .img-presentacion {}

    .divisor {}

    .tittle-big {
        font-size: 2em;
        line-height: 1.1em;
        font-family: FontBase-SemiBold;
        color: $color-inverted;
    }

    .container-a {
        margin: 0 auto;
    }

    .btn-iniciar {
        background: $color-complement-two;
        color: $color-primary;
        padding: 2px 20px;
        font-size: 2em;
        font-family: fontBase-Regular;

        &:hover {
            background: $color-primary;
            color: $color-complement-two;
        }
    }

    .logoEcopetrol {
        position: fixed;
    }

    .titulo {
        font-size: 1.6em;
    }

    .pantalla {
        @media screen and (max-width: 600px) {
            display: none;

            .logoEcopetrol {
                position: fixed;
            }
        }
    }

    .mobile {
        @media screen and (min-width: 600px) {
            display: none;
            background: url("../assets/presentacion/5-logo-portada-mobiles.png") center;
        }

        @media screen and (max-width: 600px) {
            display: block;
            background: url("../assets/presentacion/5-logo-portada-mobiles.png") center;
        }
    }
</style>